/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, hingeProfileBackgroundColor, hingeProfileImageDimension, hingeProfileItemBorderColor, hingeProfileItemDividerOpacity, hingeProfileItemBoxShadow, hingeProfileItemBorderWidth, hingeProfileItemBorderRadius, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'


export const viewHingePromptItem = (viewFeedbackTrue, giveFeedbackTrue, promptIndex, datingProfile, width) => {
  // console.log('prompt index ->', promptIndex)
  // console.log('datingProfile ->', datingProfile)
  return (
    <Box
      sx={{
        mt: 3,
        pt: 4,
        width: hingeProfileImageDimension(width),
        backgroundColor: 'white',
        boxShadow: hingeProfileItemBoxShadow, 
        border: hingeProfileItemBorderWidth,
        borderColor: hingeProfileItemBorderColor,
        borderRadius: giveFeedbackTrue ? `${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius} 0px 0px` : `${hingeProfileItemBorderRadius}`,
      }}
    >
      {/* Prompt */}
      <Box
        sx={{
          pt: 2, pb: 1, px: 3,
          fontSize: '14px',
          fontWeight: 'bold',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {datingProfile.bio.prompts[promptIndex].prompt}
      </Box>

      {/* Response */}
      <Box
        sx={{
          pt: 1, pb: 5, px: 3,
          fontFamily: 'Times',
          fontSize: datingProfile.bio.prompts[promptIndex].response.length < 25 ? '32px' : datingProfile.bio.prompts[promptIndex].response.length < 40 ? '30px' : '28px',
          fontWeight: 'bold',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {datingProfile.bio.prompts[promptIndex].response}
      </Box>

      {viewFeedbackTrue && datingProfile.bioFeedback.promptsFeedback[promptIndex].feedback.length > 0 && datingProfile.bioFeedback.promptsFeedback[promptIndex].verdict.length > 0 &&
        <Box
          sx={{
            width: hingeProfileImageDimension(width),
            // borderRadius: `0px 0px ${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.promptsFeedback[promptIndex], 'prompts', datingProfile.type)}

        </Box>
      }

    </Box>
  )
}